import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "./utils";

const pillVariants = cva(
  "inline-flex items-center justify-center gap-1.5 min-h-6 px-2 py-[3px] rounded-full text-xs font-semibold leading-4 whitespace-nowrap shrink-0 w-fit [&>svg]:size-3 [&>svg]:pointer-events-none",
  {
    variants: {
      variant: {
        success: "bg-background-positive-subtle text-background-positive-bold",
        warning: "bg-background-notice-subtle text-background-notice-bold",
        error: "bg-background-negative-subtle text-background-negative-bold",
        info: "bg-background-info-subtle text-background-info-bold",
        draft: "bg-surface-L2 text-content-primary-subtle",
      },
    },
    defaultVariants: {
      variant: "success",
    },
  },
);

function Pill({
  className,
  variant,
  ...props
}: React.ComponentProps<"span"> & VariantProps<typeof pillVariants>) {
  return (
    <span
      data-slot="pill"
      className={cn(pillVariants({ variant }), className)}
      {...props}
    />
  );
}

export { Pill, pillVariants };
